import React from 'react';
import '../Dashboard/ELearningBoard/ELearningBoard.css';

const TABS = [
    { id: 1, label: 'MY BREAKTHROUGH' },
    { id: 2, label: 'MY PATH' },
    { id: 3, label: 'ADDITIONAL PROGRAMS' },
];

/** Shared V1 e-learning board chrome for marketing captures. */
const MarketingELearningShell = ({ activeTab = 1, children }) => (
    <article className="eLearningBoardModules marketing-elboard">
        <div className="TitleDashboardContent">
            <section className="heading-5 BlueDarkText">MY E-LEARNING</section>
            <div className="LevelContainer Active">
                <b> L1</b>
            </div>
            <div className="LevelContainer Disable">
                <b> L2</b>
            </div>
            <div className="LevelContainer Disable">
                <b> L3</b>
            </div>
            <div className="LevelContainer Disable">
                <b> L4</b>
            </div>
        </div>
        <div className="ELearningModules__Container">
            <section className="ELearning__Menu">
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        type="button"
                        className={
                            activeTab === tab.id
                                ? 'ModuleTypeActive'
                                : 'btnModuleType'
                        }
                    >
                        {tab.label}
                    </button>
                ))}
            </section>
            <div className="ModuleContent__container OolaScroll">
                {children}
            </div>
        </div>
    </article>
);

export default MarketingELearningShell;
